import { render, staticRenderFns } from "./BettingHistory.vue?vue&type=template&id=53a50a55&"
import script from "./BettingHistory.vue?vue&type=script&lang=js&"
export * from "./BettingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BettingHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports